import {
  CLEAR_CART,
  FETCH_BASKET_DATA,
  REMOVE_FROM_BASKET,
} from "./actionTypes";

const initialState = {
  products: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CLEAR_CART:
      return {
        ...state,
        products: [],
      };
    case FETCH_BASKET_DATA:
      return {
        ...state,
        products: action.payload,
      };
    case REMOVE_FROM_BASKET:
      return {
        ...state,
        products: action.payload,
      };
    default:
      return state;
  }
}
